/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const LifeStyleGridItem = ({ module: { content }, errors }) => {
  const { media } = useMedia(getImage(content.slides?.[0]));

  return (
    <InfoItem.WithError
      error={errors}
      size="large"
      image={media.src}
      description={pluralize(content.slides?.length, 'article')}
    >
      Lifestyle grid
    </InfoItem.WithError>
  );
};

export default LifeStyleGridItem;
